export default __webpack_public_path__ + "static/media/Anya 9781408312957.82aad5da.jpg";